import { Link } from 'react-router-dom';
import ChevronLeft from '@/assets/icons/chevron-left.svg?react';
import styles from './back-link.module.scss';

interface BackLinkProps {
  to: string;
  label: string;
}

/** Detail views have no other way back: the shell header title is the same as the list's. */
export function BackLink({ to, label }: BackLinkProps) {
  return (
    <Link to={to} className={styles.backLink}>
      <ChevronLeft className={styles.icon} aria-hidden="true" />
      {label}
    </Link>
  );
}
